// The Status filter control — the visible half of `lib/statusFilter.ts`, used
// by every manager on References and on Rules through `ListFilters`.
//
// A MULTI-SELECT OF ACTIVE AND INACTIVE (owner, 2026-10-14: "turn the fields
// that you mentioned into multi-select options where checking both indeed does
// mean 'Any', instead of inventing a new value, like 'Any'"). What is ticked is
// the filter itself; nothing is translated.
import { STATUS_FILTER_LABEL, type StatusFilter, type StatusValue } from '../lib/statusFilter'
import { MultiSelectField, type MultiSelectOption } from './MultiSelectField'

const OPTIONS: MultiSelectOption[] = (['active', 'inactive'] as const).map((value) => ({
  value,
  label: STATUS_FILTER_LABEL[value],
}))

export function StatusFilterDropdown({
  value,
  onChange,
  popupHost,
}: {
  value: StatusFilter
  onChange: (value: StatusFilter) => void
  /** The dialog it sits in, for its list to mount inside (D-344). */
  popupHost?: HTMLElement | null
}) {
  return (
    <MultiSelectField
      label=""
      ariaLabel="Status filter"
      options={OPTIONS}
      selected={value}
      onChange={(values) => onChange(values.filter((v): v is StatusValue => v === 'active' || v === 'inactive'))}
      popupHost={popupHost}
    />
  )
}
